import React, { useEffect, useState } from "react";
import { notificationEmitter } from "../../utils/notificationEmitter";
import AlertModal from "./AlertModal";

/**
 * Global notification handler that listens to notification events
 * and displays them using AlertModal
 */
const GlobalNotificationHandler = () => {
  const [notification, setNotification] = useState(null);

  useEffect(() => {
    const unsubscribe = notificationEmitter.subscribe((notif) => {
      setNotification(notif);
    });

    return unsubscribe;
  }, []);

  const handleClose = () => {
    setNotification(null);
  };

  if (!notification) return null;

  // Map notification types to AlertModal tones
  const toneMap = {
    error: "danger",
    warning: "warning",
    success: "info",
    info: "info",
  };

  return (
    <AlertModal
      isOpen={!!notification}
      title={notification.title || "Notification"}
      message={notification.message || ""}
      tone={toneMap[notification.type] || "info"}
      hideCancel={true}
      confirmLabel="OK"
      onConfirm={handleClose}
      onClose={handleClose}
    />
  );
};

export default GlobalNotificationHandler;
